import { render, staticRenderFns } from "./userShopping.vue?vue&type=template&id=5105b952&scoped=true"
import script from "./userShopping.vue?vue&type=script&lang=js"
export * from "./userShopping.vue?vue&type=script&lang=js"
import style0 from "./userShopping.vue?vue&type=style&index=0&id=5105b952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5105b952",
  null
  
)

export default component.exports